import { ASSIGNMENT_CONVERT_DUE_TIME_BEFORE, Icons, formatDate, getTimePassedFrom } from '../../utils/utilities'
import SubmitAssignmentDialog from '../user/SubmitAssignmentDialog'
import { useAssignmentStore } from '../../store/assignment.store'
import React, { useCallback, useEffect, useState } from 'react'
import DataLoadingSpinner from '../common/DataLoadingSpinner'
import { useUserStore } from '../../store/user.store'
import { Box, IconButton, Tab, Card, Tabs, Tooltip, Typography, useTheme, Button } from '@mui/material'
import noTasksImg from '../../assets/noassignment.svg'
import { Link, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react'
import { SubjectIcon } from '../../assets/custom-icons'
import AssignmentViewer from '../common/AssignmentViewer'
import CountBadge from '../common/CountBadge'
import CustomChip from '../common/CustomChip'
import CustomTooltip from '../common/CustomTooltip'
import dayjs from 'dayjs'

const PendingOrRecentAssignmentsCard = observer( ( { title, subject } ) => {

    const [tabValue, setTabValue] = useState( "pending" )
    const [openAssignmentSubmission, setOpenAssignmentSubmission] = useState( false )
    const [selectedAssignmentData, setSelectedAssignmentData] = useState( {} )
    const [isAssignmentsLoaded, setIsAssignmentsLoaded] = useState( false )
    const [assignmentDetailsViewerAssignment, setAssignmentDetailsViewerAssignment] = useState( null )

    const AssignmentStore = useAssignmentStore()
    const UserStore = useUserStore()

    const { palette, border } = useTheme()

    const navigate = useNavigate()

    const getAssignments = useCallback( async () => {
        if ( AssignmentStore.getErrors.recentAssignments )
            await AssignmentStore.fetchDueOrRecentAssignments( subject ? subject.subject_id : undefined )
        setIsAssignmentsLoaded( true )
    }, [AssignmentStore, subject]
    )

    const handleClickOpenAssignmentSubmission = ( value ) => {
        if ( UserStore.getUser["user_role"] === "STUDENT" ) {
            setSelectedAssignmentData( value )
            setOpenAssignmentSubmission( true )
        } else navigate( `/faculty/assignment/${value.assignment_id}` )
    }

    const handleCloseAssignmentSubmission = ( value ) => {
        setOpenAssignmentSubmission( false )
        setSelectedAssignmentData( value )
    }

    const handleTabChange = ( e, val ) => {
        setTabValue( val )
    }

    const assignmentFileterFunc = a => {
        if ( UserStore.getUser.user_role === 'STUDENT' ) {
            let dueDate = dayjs( a.assignment_created_at ) < dayjs( ASSIGNMENT_CONVERT_DUE_TIME_BEFORE ) ?
                dayjs( dayjs( a.assignment_due_date ).format( "YYYY-MM-DD" ) ).add( 1, 'day' ) :
                dayjs( a.assignment_due_date )

            const pending = +a.submission_exists === 0 && dueDate > dayjs()
            return tabValue === 'pending' ? pending : !pending
        } else {
            let dueDate = dayjs( a.assignment_created_at ) < dayjs( ASSIGNMENT_CONVERT_DUE_TIME_BEFORE ) ?
                dayjs( dayjs( a.assignment_due_date ).format( "YYYY-MM-DD" ) ).add( 1, 'day' ) :
                dayjs( a.assignment_due_date )
            const pending = dueDate > dayjs()
            return tabValue === 'pending' ? pending : !pending
        }
    }

    useEffect( () => {
        const getData = () => {
            getAssignments()
        }
        getData()
    }, [getAssignments] )
    // boxShadow="1px 1px 5px 0px rgba(0,0,0,0.1)"
    return (
        <Box gridArea="prac" display="flex" minHeight="400px" flexDirection="column">
            <Box marginBottom="5px" height="25px" display="flex" gap="10px" alignItems="center">
                <Link className='default-link' to={UserStore.getUser["user_role"] === "STUDENT" ? `/student/assignment` : `/faculty/assignment`}>
                    <Typography sx={{ ":hover .redirect-arrow": { transform: "translate(2px,-2px)", color: "primary.main" } }} display="flex" gap="5px" alignItems="center" variant='subtitle2' component="h3" flexGrow={1}>
                        <Typography component="span" display="flex" alignItems="center" color='primary'>{Icons.default.DescriptionIcon}</Typography>
                        Recent Assignments
                        <Typography component="span" color='textSecondary' className='redirect-arrow' display="flex" alignItems="center">{Icons.default.ArrowOutward}</Typography>
                        {/* {AssignmentStore.getDueOrRecentAssignments?.length > 0 && <CountBadge value={AssignmentStore.getDueOrRecentAssignments?.length} />} */}
                    </Typography>

                </Link>
            </Box>

            <Card elevation={0} sx={{ flexGrow: 1 }}>
                <Box display="flex" overflow="hidden" height="100%" flexDirection="column" minWidth="200px" flexGrow={1}>

                    <SubmitAssignmentDialog getAssignments={getAssignments} selectedValue={selectedAssignmentData} open={openAssignmentSubmission} onClose={handleCloseAssignmentSubmission} />
                    <AssignmentViewer loaded={true} selectedValue={assignmentDetailsViewerAssignment} open={Boolean( assignmentDetailsViewerAssignment )} onClose={() => setAssignmentDetailsViewerAssignment( null )} />

                    <Box display="flex" flexGrow={1} overflow="auto" flexDirection="column">
                        {isAssignmentsLoaded && AssignmentStore.getDueOrRecentAssignments.length > 0 && <Box width="100%" display="flex" justifyContent="flex-start" flexDirection="column">
                            <Box position="relative" sx={{ "&::after": { content: `''`, height: "2px", width: "100%", position: "absolute", left: "0", bottom: "0", zIndex: 1 } }}>
                                <Tabs sx={{ position: "relative", zIndex: 2, borderBottom: border[1] }} scrollButtons="auto" variant='scrollable' value={tabValue} onChange={handleTabChange}>
                                    <Tab sx={{ padding: "2px 10px" }} value="pending"
                                        label={
                                            <Box display="flex" alignItems="center" gap="10px" fontWeight="700" fontSize="14px" textTransform="capitalize">
                                                Pending
                                                <CountBadge value={AssignmentStore.getDueOrRecentAssignments.filter( a => {
                                                    if ( UserStore.getUser.user_role === 'STUDENT' ) {
                                                        let dueDate = dayjs( a.assignment_created_at ) < dayjs( ASSIGNMENT_CONVERT_DUE_TIME_BEFORE ) ?
                                                            dayjs( dayjs( a.assignment_due_date ).format( "YYYY-MM-DD" ) ).add( 1, 'day' ) :
                                                            dayjs( a.assignment_due_date )
                                                        const pending = +a.submission_exists === 0 && dueDate > dayjs()
                                                        return pending
                                                    } else {
                                                        let dueDate = dayjs( a.assignment_created_at ) < dayjs( ASSIGNMENT_CONVERT_DUE_TIME_BEFORE ) ?
                                                            dayjs( dayjs( a.assignment_due_date ).format( "YYYY-MM-DD" ) ).add( 1, 'day' ) :
                                                            dayjs( a.assignment_due_date )
                                                        return dueDate > dayjs()
                                                    }
                                                } ).length} />
                                            </Box>} />
                                    <Tab sx={{ padding: "2px 10px" }} value="all" label={<Typography fontWeight="700" variant='subtitle2' textTransform="capitalize">Completed</Typography>} />
                                </Tabs>
                            </Box>
                            {AssignmentStore.getDueOrRecentAssignments
                                .filter( assignmentFileterFunc )
                                .map( ( item, index ) => {

                                    let dueDate = dayjs( item.assignment_created_at ) < dayjs( ASSIGNMENT_CONVERT_DUE_TIME_BEFORE ) ?
                                        dayjs( dayjs( item.assignment_due_date ).format( "YYYY-MM-DD" ) ).add( 1, 'day' ) :
                                        dayjs( item.assignment_due_date )

                                    return (
                                        <Box
                                            key={item.assignment_id}
                                            sx={{
                                                minWidth: 0,
                                                margin: "10px",
                                                borderRadius: "5px",
                                                alignItems: "flex-start",
                                                display: "flex",
                                                gap: "10px",
                                                padding: "5px",
                                                transition: "0.1s ease",
                                                cursor: "pointer",
                                                ":hover": {
                                                    bgcolor: palette.rowHover
                                                }
                                            }}>
                                            <Box borderRadius="50%" overflow="clip" position="relative" display="flex" alignItems="center" padding="2px" sx={{ width: "8px", aspectRatio: "1 / 1", fontSize: "12px", background: item.assignment_submission_mode === "online" ? palette.success.main : palette.customThemeColor.main }} marginTop="5px">

                                            </Box>
                                            <Box flexGrow={1} onClick={() => setAssignmentDetailsViewerAssignment( item )} minWidth={0} overflow="hidden" display="flex" flexDirection="column" alignItems="flex-start">
                                                <Typography noWrap fontSize="14px" width="100%" minWidth={0} textTransform="capitalize" title={item.assignment_name} fontWeight="500">{item.assignment_name}</Typography>
                                                <Typography display="flex" alignItems="center" gap="5px" noWrap fontSize="12px" > {Icons.default.User} {item.author_name}</Typography>
                                                <Typography display="flex" alignItems="center" gap="5px" fontSize="12px" > {Icons.default.Calendar} Created {getTimePassedFrom( item.assignment_created_at )}</Typography>
                                                <Box display="flex" alignItems="center" flexWrap="wrap" gap="5px">
                                                    <CustomChip tooltipTitle={`Submission mode`} value={item.assignment_submission_mode} />
                                                    {item?.assignment_subject?.subject_name && <CustomChip tooltipTitle={`Subject: ${item.assignment_subject.subject_name}`} value={item.assignment_subject?.subject_code} />}
                                                    <CustomChip variant='filled' tooltipTitle={`Submit before the deadline`} color="error" value={`Due: ${dayjs( item.assignment_created_at ) < dayjs( ASSIGNMENT_CONVERT_DUE_TIME_BEFORE ) ?
                                                        `${dayjs( item.assignment_due_date ).format( "DD MMM YYYY" )}, 11:59 PM` :
                                                        dayjs( item.assignment_due_date ).format( "DD MMM YYYY, hh:mm A" )
                                                        }`} />
                                                </Box>

                                            </Box>
                                            {UserStore.getUser.user_role === 'STUDENT' && +item?.submission_exists === 0 && dueDate > new Date() && <CustomTooltip title={item.assignment_submission_mode === "offline" ? "Submit this offline assignment via the yellow book or as otherwise instructed by your faculty." : "Submit assignment"}>
                                                <Box sx={{ cursor: item.assignment_submission_mode === "offline" ? "not-allowed" : "pointer" }} component="span">
                                                    <IconButton disabled={item.assignment_submission_mode === "offline"} color='primary' onClick={( e ) => handleClickOpenAssignmentSubmission( item )} size="small">
                                                        {Icons.default.Upload}
                                                    </IconButton>
                                                </Box>
                                            </CustomTooltip>}
                                            {UserStore.getUser.user_role !== 'STUDENT' && <Tooltip placement='top' title="View Submissions">
                                                <Box sx={{ cursor: "pointer" }} onClick={e => handleClickOpenAssignmentSubmission( item )} display="flex" gap="10px" flexDirection="column" alignItems="center">
                                                    <Typography variant='body2' fontSize="12px">Submissions</Typography>
                                                    <Box display="flex" sx={{ aspectRatio: 1 }} alignItems="center" justifyContent="center" height="60px" width="60px" borderRadius="50%" border={`6px solid ${palette.error.main}`} >
                                                        <Typography fontWeight="800" color="error" variant='h5'>{item?.submission_count || 0}</Typography>
                                                    </Box>
                                                </Box>
                                            </Tooltip>}
                                        </Box>
                                    )
                                } )}
                        </Box>}
                        {( !isAssignmentsLoaded ) && <Box display="flex" justifyContent="center">
                            <DataLoadingSpinner />
                        </Box>}
                        {isAssignmentsLoaded && AssignmentStore.getDueOrRecentAssignments.filter( assignmentFileterFunc ).length === 0 && <Box padding="20px" display="flex" flexGrow={1} alignItems="center" flexDirection="column" gap="20px" justifyContent="center">
                            <img width="150px" src={noTasksImg} alt="No pending tasks" />
                            <Typography variant="subtitle2">{tabValue === 'pending' ? "Relax no pending" : "No recently completed"}  assignments!</Typography>
                        </Box>}
                    </Box>
                </Box>
            </Card>
        </Box>
    )
} )

export default PendingOrRecentAssignmentsCard
